import React from 'react'
import { Link } from 'react-router-dom'

const Footer = () => {
  return (
    <footer className='bg-blue-950 mx-auto max-w-[1024px] rounded-tl-3xl rounded-tr-3xl'>
        <div className='w-full px-4 pt-16 pb-8 md:p-16 md:pb-8'>
            <div className='flex flex-col md:flex-row gap-12'>
                <div>
                    <h4 className='text-2xl font-semibold text-slate-200 mb-2'>Contact Info</h4>
                    <p className='text-slate-400'>Dankuni, Hooghly, <br /> West Bengal - 712311, India</p>
                    <p className='text-slate-400'>Customer Care : +91 8900689991</p>
                    <Link to='mailto:info@macrum.in' className='text-slate-400'>Mail : info@macrum.in</Link>
                </div>
                <div className='flex flex-col'>
                    <h4 className='text-2xl font-semibold text-slate-200 mb-2'><br /></h4>
                    <Link to='/contact' className='text-slate-400'>Contact Us</Link>
                    <Link to='' className='text-slate-400'>Terms & Conditions</Link>
                </div>
            </div>
            <div>
                <div className='w-64 lg:w-80 flex flex-col-reverse md:flex-row gap-4 justify-between p-xs mt-12 md:mt-16 mx-auto items-center'>
                    <p>&copy; MACRUM</p>
                    <div className='text-slate-400'>
                        <Link to='/'>Privacy Policy</Link>
                    </div>
                </div>
            </div>
        </div>
    </footer>
  )
}

export default Footer
